import React from 'react';

import './Styles/Footer.css'

export default function Footer() {
    return (
        <div className = "footer">
            <div>
                <p>Copyright © 2023 | All Rights Reserved</p>
            </div>
        </div>
        
    );
}